import React from 'react';
import PropTypes from "prop-types";

class TaskPlay extends React.PureComponent {
    render() {
        const {task, onTaskUpdate} = this.props;
        return <h1>Task Play</h1>
    }
}

TaskPlay.propTypes = {
    task: PropTypes.object,
    onTaskUpdate: PropTypes.func,
    isCheck: PropTypes.bool,
}
export default TaskPlay;
